import AxiosJob from '@/services/api/job/axios_job'

export default {
  createLane: (data) => {
    return AxiosJob.post('lane', data)
  },

  updateLane: (laneId, data) => {
    return AxiosJob.put(`lane/${laneId}`, data)
  },

  getLanesFromPool: (poolId) => {
    return AxiosJob.get(`lane/pool/${poolId}`)
  },

  getLanesByUser: () => {
    return AxiosJob.get(`lane/user`)
  },

  getLane: (laneId) => {
    return AxiosJob.get(`lane/${laneId}`)
  },

  deleteLane: (laneId) => {
    return AxiosJob.delete(`lane/${laneId}`)
  }
}
